import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomTooltip = ({
  text,
  children,
  classString,
  placement,
  disabled = 0,
}) => {
  const tooltipContainer = classString
    ? typeof classString === "string"
      ? document.querySelector(classString)
      : classString
    : null;

  const renderTooltip = (props) => (
    <Tooltip
      id="tooltip"
      style={{
        display: disabled ? "none" : "block",
      }}
    >
      {props}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      disabled
      placement={placement ?? "top"}
      overlay={renderTooltip(text)}
      container={tooltipContainer}
    >
      {children}
    </OverlayTrigger>
  );
};

export default CustomTooltip;
